import { render, staticRenderFns } from "./WorkflowOpen.vue?vue&type=template&id=4711342c&scoped=true"
import script from "./WorkflowOpen.vue?vue&type=script&lang=ts"
export * from "./WorkflowOpen.vue?vue&type=script&lang=ts"
import style0 from "./WorkflowOpen.vue?vue&type=style&index=0&id=4711342c&prod&scoped=true&lang=scss"
import style1 from "./WorkflowOpen.vue?vue&type=style&index=1&id=4711342c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4711342c",
  null
  
)

export default component.exports